import React, { useEffect, useRef, useState } from 'react';
import { RenderingOptions, useManager, useRenderingOptions } from '@src/contexts/WarsContext';
import { WarsEvents, LoadSceneEvent, WarsScenes, ErrorEvent, UIContextEvent, StateSyncEvent } from '@playroomkit/pr-wars/events';
import { WarsGame } from '@playroomkit/pr-wars';
import { RoundData, UIContextType } from '@playroomkit/pr-wars-data';

const setupScene = async (mountRef: HTMLDivElement, manager: WarsGame, options: RenderingOptions) => {
  
  // Load the game scene
  await manager.loadGameShowScene(mountRef, options.pixelRatio, options.parameters);
  
  // Enable free camera
  manager.enableCameraControls(true);

  const text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc fringilla convallis rhoncus.'

  // Send some data
  const roundData = new RoundData(5, 'topic-thunder', [], '123456', text, text, text, text, [], [], [], false, '', '', [], '123456', true, [], [], '', UIContextType.TOPIC);
  document.dispatchEvent(new StateSyncEvent(roundData));
};

const DebugScene: React.FC = () => {

  const [showUI, setShowUI] = useState(false);
  const mountRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const manager = useManager();
  const options = useRenderingOptions();

  useEffect(() => {
    const handleLoadSceneEvent = (event: Event) => {
      const e = event as LoadSceneEvent;
      const display = e.sceneName === WarsScenes.SceneTest;

      setShowUI(display);
    }

    const handleResize = () => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    };

    document.addEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvent);
    window.addEventListener('resize', handleResize);

    // Only run setupScene when the mountRef is available
    if (mountRef.current) {
      setupScene(mountRef.current, manager, options);
    }

    // Cleanup function to remove event listeners
    return () => {
      document.removeEventListener(WarsEvents.LoadSceneEvent, handleLoadSceneEvent);
      window.removeEventListener('resize', handleResize);
    };
}, [showUI]);


return (
  <>
  {showUI && (
  <div>
    <div
      ref={mountRef}
      style={{ width: `${width}px`, height: `${height}px`}}
    />
  </div>
  )}
  </>
)};

export default DebugScene;